var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOndemandNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.617 0 24 5.38302 24 12C24 18.617 18.617 24 12 24C5.38302 24 0 18.617 0 12C0 5.38302 5.38302 0 12 0ZM12 1.7561C6.35122 1.7561 1.7561 6.35122 1.7561 12C1.7561 17.6488 6.35122 22.2439 12 22.2439C17.6488 22.2439 22.2439 17.6488 22.2439 12C22.2439 6.35122 17.6488 1.7561 12 1.7561ZM11.5092 7.91579C12.118 8.16983 16.39 10.3579 16.39 11.9946C16.39 13.5283 12.5453 15.6731 11.5631 16.0828C11.1803 16.242 10.7436 16.3919 10.335 16.3919C10.0189 16.3919 9.71918 16.3017 9.4745 16.0582C9.28601 15.8721 8.78259 15.3745 8.78025 12.0976C8.77908 8.61822 9.3024 8.10076 9.4745 7.92866C10.0868 7.32222 11.0843 7.73783 11.5092 7.91579ZM10.6932 9.467C10.486 10.6389 10.4825 13.4381 10.6897 14.5503C11.7176 14.1874 13.9444 12.724 14.5438 11.9993C13.9467 11.2957 11.7481 9.86271 10.6932 9.467Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOndemandNav);
export default __webpack_public_path__ + "static/media/ondemandNav.74c6efed05fdc8ca4c0ab6b39b6ab85a.svg";
export { ForwardRef as ReactComponent };